<template>
  <Template>
    <TestimonialDetail />
  </Template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import Template from '@/components/Templates/Kozhencherry.vue';
import TestimonialDetail from '@/components/TestimonialDetail/Template2/index.vue';
import { TESTIMONIAL_DETAIL_PAGE_NAMES } from '@/ts/enum';

export default defineComponent({
  name: TESTIMONIAL_DETAIL_PAGE_NAMES.POYANIL_HOSPITAL_KOZHENCHERRY,
  components: {
    TestimonialDetail,
    Template,
  },
});
</script>
